import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { RESTRICTED_OPTION_TOOLTIP } from 'customer-data-filters-ui/utils/fieldLevelPermissions';
import { HideIcon } from 'foundations-assets';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const RestrictedPropertyIcon = () => {
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "top",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: RESTRICTED_OPTION_TOOLTIP
    }),
    children: /*#__PURE__*/_jsx(View, {
      paddingInline: "25",
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(HideIcon, {
        color: "icon-primary-disabled"
      })
    })
  });
};
export default RestrictedPropertyIcon;